<template>
  <div>
    <app-head></app-head>
    <app-body>
      <div>
        <div class="about-us-background">
          <div class="banner-content-white-text">
            <h1 style="font-family: STCaiyun, Arial, sans-serif;">客户案例</h1>
            <hr>
            <p>
              我们深知每个客户都有其独特的需求和特点，以贴心、周到的服务赢得客户的信赖和认可
            </p>
          </div>
          <div class="breadcrumb-container">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item>
                <router-link to="/"><i class="el-icon-house"></i> 首页</router-link>
              </el-breadcrumb-item>
              <el-breadcrumb-item>客户案例</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>

        <!-- 案例卡片列表 -->
        <div class="cases-container" v-if="normalizedCases.length > 0">
          <div
            class="case-card"
            v-for="item in normalizedCases"
            :key="item.id"
            @click="openCase(item)"
          >
            <div class="case-card-img-wrap">
              <template v-if="item.imageList.length">
                <img
                  v-for="(img, idx) in item.imageList"
                  :key="img + idx"
                  :src="img"
                  :alt="item.title"
                  class="case-card-img"
                  :class="{ 'is-active': idx === currentIndex(item.id) }"
                />
                <!-- 多图时展示指示点 -->
                <div class="case-card-dots" v-if="item.imageList.length > 1">
                  <span
                    v-for="n in item.imageList.length"
                    :key="'dot' + n"
                    class="case-dot"
                    :class="{ 'is-active': n - 1 === currentIndex(item.id) }"
                  ></span>
                </div>
              </template>
            </div>
            <div class="case-card-body">
              <h3 class="case-card-title">{{ item.title }}</h3>
              <p class="case-card-desc">{{ item.summary }}</p>
              <div class="case-card-tags">
                <span class="case-tag" v-for="tag in item.tags" :key="tag">{{ tag }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 空状态 -->
        <div class="news-content" v-else>
          <span class="icon iconfont icon-zanwuneirongwudingdanwuneirong" style="font-size: 400px;"></span>
          <p style="font-size: 40px; font-weight: bold;">暂无内容</p>
        </div>

      </div>
    </app-body>
    <app-foot></app-foot>
  </div>
</template>

<script>
import AppHead from '../common/AppHeader.vue';
import AppBody from '../common/AppPageBody.vue'
import AppFoot from '../common/AppFoot.vue'
import remoteDesk from '../../../assets/customerCase/remoteDesk.png'
import voicePrint1 from '../../../assets/customerCase/声纹1.png'
import voicePrint2 from '../../../assets/customerCase/声纹2.png'

// 封面轮播间隔（毫秒）
const SLIDE_INTERVAL = 2000

export default {
  name: "index",
  components: {
    AppHead,
    AppBody,
    AppFoot
  },
  data() {
    return {
      // 模拟案例数据 —— 后续替换为后端接口
      caseList: [
        {
          id: 1,
          title: 'FOCUS - 智能制造全栈式融合管控平台',
          summary: '为分布式工控终端提供实时远程控制、录音质检与集中运维管理，数据不出域，安全可控。',
          coverImage: remoteDesk,
          tags: ['远程控制', '音视频质检', '集中运维'],
        },
        {
          id: 2,
          title: 'AI声纹与视觉融合智能检测系统',
          summary: '将声音特征分析、AI声纹识别、机器视觉、设备控制与数据追溯整合到同一平台，让装配质检更准确、更稳定、可追溯。',
          // 多张封面图：填 images 数组即可自动轮播；只填 coverImage 则显示单图
          coverImage: voicePrint1,
          images: [voicePrint1, voicePrint2],
          tags: ['AI声纹识别', '机器视觉', '多源融合检测', '产线集成'],
        }
      ],
      // 各案例当前显示的封面图下标 { [id]: index }
      slideIndex: {},
      slideTimer: null,
    }
  },
  computed: {
    // 统一封面数据：优先 images，其次 coverImage，保证单图案例不受影响
    normalizedCases() {
      return this.caseList.map(item => {
        let imageList = item.images && item.images.length ? item.images : []
        if (!imageList.length && item.coverImage) imageList = [item.coverImage]
        return { ...item, imageList }
      })
    },
  },
  created() {
    const map = {}
    this.normalizedCases.forEach(item => { map[item.id] = 0 })
    this.slideIndex = map
  },
  mounted() {
    this.startSlide()
  },
  beforeDestroy() {
    this.stopSlide()
  },
  methods: {
    openCase(item) {
      this.$router.push({ path: '/customerCaseDetail', query: { id: item.id } })
    },
    currentIndex(id) {
      return this.slideIndex[id] || 0
    },
    startSlide() {
      this.stopSlide()
      this.slideTimer = setInterval(() => {
        const next = {}
        let changed = false
        this.normalizedCases.forEach(item => {
          const total = item.imageList.length
          if (total > 1) {
            next[item.id] = ((this.slideIndex[item.id] || 0) + 1) % total
            changed = true
          } else {
            next[item.id] = 0
          }
        })
        if (changed) this.slideIndex = next
      }, SLIDE_INTERVAL)
    },
    stopSlide() {
      if (this.slideTimer) {
        clearInterval(this.slideTimer)
        this.slideTimer = null
      }
    },
  },
}
</script>

<style scoped>

/* ====== Banner（保持原样） ====== */
.about-us-background {
  width: 100%;
  background-image: url("../../../assets/img/contact-bg.jpg");
  margin-top: -30px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  min-height: 500px
}

.banner-content-white-text {
  position: absolute;
  top: 40%;
  left: 50%;
  color: white;
  transform: translate(-50%, -50%);
  text-align: center;
}

.breadcrumb-container {
  position: absolute;
  left: 50%;
  bottom: 20px;
  transform: translateX(-50%);
  background-color: rgba(255, 255, 255, 0.5);
  padding: 8px 16px;
  border-radius: 4px;
  width: auto;
  min-width: max-content;
}

.banner-content-white-text h1 {
  font-size: 36px;
  margin-bottom: 20px;
}

/* ====== 空状态（保持原样） ====== */
.news-content {
  display: flex; /* 使用 Flexbox 布局 */
  flex-direction: column; /* 子元素垂直排列 */
  align-items: center; /* 子元素在交叉轴（水平方向）上居中 */
  justify-content: center; /* 子元素在主轴（垂直方向）上居中 */
  min-height: 300px; /* 设置最小高度，确保内容有足够空间显示 */
  text-align: center; /* 文本居中 */
  color: rgb(181 181 181);
}

.news-content .icon {
  display: block; /* 将图标设置为块级元素 */
  margin-bottom: 16px; /* 图标与文本之间添加间距 */
  margin-top: 50px;
}

/* ====== 案例卡片网格 ====== */
.cases-container {
  max-width: 1200px;
  margin: 50px auto 60px;
  padding: 0 30px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.case-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.case-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 8px 30px rgba(13, 74, 110, 0.15);
}

.case-card-img-wrap {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 10;
  overflow: hidden;
  background: #f2f5f8;
}

.case-card-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  transform: scale(1.02);
  transition: opacity 0.8s ease, transform 0.6s ease;
}

.case-card-img.is-active {
  opacity: 1;
  transform: scale(1);
}

.case-card:hover .case-card-img.is-active {
  transform: scale(1.05);
}

/* 封面多图指示点 */
.case-card-dots {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 10px;
  display: flex;
  justify-content: center;
  gap: 6px;
  z-index: 2;
}

.case-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.55);
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.25);
  transition: width 0.3s ease, background 0.3s ease;
}

.case-dot.is-active {
  width: 18px;
  border-radius: 3px;
  background: #fff;
}

.case-card-body {
  padding: 20px 22px 22px;
}

.case-card-title {
  font-size: 18px;
  font-weight: 700;
  color: #0B2A4A;
  margin: 0 0 10px;
  line-height: 1.4;
}

.case-card-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin: 0 0 14px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.case-card-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.case-tag {
  display: inline-block;
  padding: 3px 12px;
  font-size: 12px;
  color: #0D4A6E;
  background: rgba(13, 74, 110, 0.08);
  border-radius: 20px;
  line-height: 1.6;
}

/* ====== 响应式 ====== */
@media (max-width: 1024px) {
  .cases-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .cases-container {
    grid-template-columns: 1fr;
    padding: 0 16px;
  }
}

/* ====== 移动端适配（与项目统一断点 768px） ====== */
@media screen and (max-width: 768px) {
  .about-us-background {
    min-height: 360px;
  }
  .banner-content-white-text {
    width: 90%;
    top: 45%;
  }
  .banner-content-white-text h1 {
    font-size: 28px;
    margin-bottom: 14px;
  }
  .banner-content-white-text p {
    font-size: 14px;
    line-height: 1.6;
    padding: 0 10px;
  }
  .breadcrumb-container {
    bottom: 12px;
    width: auto;
    min-width: max-content;
    max-width: 92%;
    padding: 6px 12px;
  }
  .breadcrumb-container .el-breadcrumb {
    display: inline-flex !important;
    flex-wrap: nowrap !important;
    font-size: 12px;
  }
  .breadcrumb-container .el-breadcrumb__item,
  .breadcrumb-container .el-breadcrumb__inner,
  .breadcrumb-container .el-breadcrumb__separator {
    white-space: nowrap !important;
    flex-shrink: 0 !important;
  }

  /* 空状态 */
  .news-content {
    min-height: 220px;
  }
  .news-content .icon {
    font-size: 180px !important;
    margin-top: 30px;
  }
  .news-content p {
    font-size: 22px !important;
  }
}

</style>